<!-- SPDX-License-Identifier: AGPL-3.0-only -->

<script setup lang="ts">
import AppDialogHost from "./components/AppDialogHost.vue";
</script>

<template>
  <RouterView />
  <AppDialogHost />
</template>
